import axios, { AxiosRequestConfig } from 'axios';
import { Toast } from 'vant';
import host from '@/config/host';
import { BaseUtil } from '@xl/js-utils';
import { AppModule } from '@/store/modules/app';
import ua from '@xl/user-agent';
import { jumpLogin } from '@/common/jump-login';
import { IdCardCheckEnum } from '@/enums';
import router from '@/router';
import Encryption from '@/common/encryption';

const { appRevision: xl_revision, appVersion: xl_version } = ua.parse();
export const tokenFailCode = [30002, 21001, 10001];
export const VINREPEATCODE = 8040002;
const codeNoShowToast = [VINREPEATCODE];
const noJumpLoginPath = ['/welcome'];

/**
 * 创建axios实例
 *
 * config.showLoading 请求时显示 Loading, 默认不显示
 * config.showError 请求报错时显示错误信息，默认显示
 */
const instanceDcs = axios.create({
  baseURL: `${host.DCS_API_HOST}`,
  withCredentials: true,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const instanceDic = axios.create({
  baseURL: `${host.DIC_API_HOST}`,
  withCredentials: true,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const instanceDpc = axios.create({
  baseURL: `${host.DPC_API_HOST}`,
  withCredentials: true,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const instanceDrisk = axios.create({
  baseURL: `${host.DRISK_API_HOST}`,
  withCredentials: true,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const reqeustSuccess = async (config: any) => {
  const { driver_md5, revision, ref, token } = AppModule.urlParams || {};
  const commonParams = {
    driver_md5,
    revision,
    token: token || AppModule.token || '',
    xl_revision,
    xl_version,
    ref,
    _su: BaseUtil.createSu(),
    // 把 java api 名称加到请求里，方便查看日志
    _name: config?.data?.name || '',
    _channel: 'h5',
  };

  config.params = {
    ...config.params,
    ...commonParams,
  };

  config.data = {
    version: '1.0', // 接口版本号
    ...config.data,
    ...commonParams,
  };


  // 通知网关，本次请求传参已加密
  if (config?.custom?.isReqEncrypt) {
    const reqEncryptHeaders = await Encryption.getReqEncryptHeaders();
    if (reqEncryptHeaders) {
      config.headers = {
        ...config.headers,
        ...reqEncryptHeaders,
      };
      config.data = Encryption.formatReqEnscryptData(config.data);
    }
  }
  // 通知网关，本次请求返回值需要加密
  if (config?.custom?.isResEncrypt) {
    const resEncryptHeaders = await Encryption.getResEncryptHeaders();
    config.headers = {
      ...config.headers,
      ...resEncryptHeaders,
    };
  }

  return config;
};

const reqeustError = (error: Error) => {
  // 对请求错误做些什么
  return Promise.reject(error);
};

const responseSuccess = (response: any) => {
  const res = response.data;

  const config: AxiosRequestConfig & {
    showError?: boolean;
  } = response.config;
  const currentPath = router.currentRoute.path;

  // 业务异常状态码
  if (res && res.ret != null && res.ret != 0) {
    const message = res.msg || '系统错误';
    const code = res.ret;
    // dic接口需要登录的状态码
    if (tokenFailCode.includes(code) && !noJumpLoginPath.includes(currentPath)) {
      // app内容 h5外 微信小程序
      Toast({ message: '登录失效，请重新登录' });
      setTimeout(() => {
        jumpLogin();
      }, 2000);
    }
    if (config.showError !== false) {
      const code = res.ret;
      // dic接口需要登录的状态码

      if (!([IdCardCheckEnum.OCCUPIED, ...tokenFailCode, ...codeNoShowToast].includes(code))) {
        setTimeout(() => {
          Toast(message);
        }, 0);
      }
    }
    // 业务异常时，reject 与请求失败一样的结构体
    const error: Error & {
      response?: any;
    } = new Error(message);
    error.response = response;

    return Promise.reject(error);
  }

  if (Encryption.isExitResEncryptHeader(response.headers)) {
    res.data = Encryption.safeUrlBase64Decrypt(res.data)
  }

  return Promise.resolve(res);
};

const responseError = (error: any) => {
  const config = (error.response || {}).config || {};
  if (config.showError !== false) {
    Toast(error.message || '系统错误');
  }
  return Promise.reject(error);
};

// 添加请求拦截器
instanceDcs.interceptors.request.use(reqeustSuccess, reqeustError);

// 添加响应拦截器
instanceDcs.interceptors.response.use(responseSuccess, responseError);

// 添加请求拦截器
instanceDic.interceptors.request.use(reqeustSuccess, reqeustError);

// 添加响应拦截器
instanceDic.interceptors.response.use(responseSuccess, responseError);

// 添加请求拦截器
instanceDpc.interceptors.request.use(reqeustSuccess, reqeustError);

// 添加响应拦截器
instanceDpc.interceptors.response.use(responseSuccess, responseError);

// 添加请求拦截器
instanceDrisk.interceptors.request.use(reqeustSuccess, reqeustError);

// 添加响应拦截器
instanceDrisk.interceptors.response.use(responseSuccess, responseError);

export { instanceDcs, instanceDic, instanceDpc, instanceDrisk };
